function injectDash(str) {
	// replaces the comma separating the day and date with a dash
	const lastCommaIndex = str.lastIndexOf(',');
	return `${str.substring(0, lastCommaIndex)} - ${str.substring(
		lastCommaIndex + 1
	)}`;
}
export function initMiniListView(
	FullCalendar,
	_calendarstartdefault,
	_upcomingEventLimit,
	_timeZone,
	_timeZoneCustom
) {
	const miniListViewConfig = {
		type: 'listWeek',
		duration: { weeks: 1 },

		content(props) {
			const segs = FullCalendar.sliceEvents(props, false);
			let sorted = segs.sort((a, b) => a.range.start - b.range.start);

			sorted = sorted.filter(
				(item) =>
					Date.parse(
						FullCalendar.formatDate(item.range.start, {
							timeZone:
								_timeZone.toString() === '2'
									? `${_timeZoneCustom}`
									: 'local',
						})
					) >=
					Date.parse(
						FullCalendar.formatDate(_calendarstartdefault, {
							timeZone:
								_timeZone.toString() === '2'
									? `${_timeZoneCustom}`
									: 'local',
						})
					)
			);
			sorted = sorted.slice(0, _upcomingEventLimit);

			const html = `
				<ul id="upcomingEventsList" style="display: flex; flex-direction: column">
						${sorted
							.map(
								(seg) =>
									`
								<li class="upcomingEventsItem" style="display: flex; margin-bottom: 8px">
									<span style="flex-basis: 50%">
									${injectDash(
										FullCalendar.formatDate(
											seg.range.start,
											{
												month: 'short',
												weekday: 'short',
												day: 'numeric',
												timeZone:
													_timeZone.toString() === '2'
														? `${_timeZoneCustom}`
														: 'local',
											}
										)
									)}
									</span>
									<span class="upcomingEventTitle" style="flex-basis: 50%; text-overflow: ellipsis; overflow: hidden; max-width: 14ch; white-space:nowrap">${
										seg.def.title === 'undefined'
											? 'Busy'
											: seg.def.title
									}</span>
									<span class="upcomingEventStart" style="display: none">${seg.range.start}</span>
									<span class="upcomingEventEnd" style="display: none">${seg.range.end}</span>
									<span class="upcomingEventDescription" style="display: none">${
										seg.def.extendedProps.description
									}</span>
									<span class="upcomingEventUrl" style="display: none">${seg.def.url}</span>
								</li>
								`
							)
							.join('')}
				</ul>
				`;

			return { html };
		},
	};
	return miniListViewConfig;
}
